export default __webpack_public_path__ + "static/media/image1a.d2dccf17.png";